import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";
import { SERVICE_NAME } from "@zapier/utils";

export enum ZapSearchInteractionOptions {
  All = "all",
  AppConnection = "app_connection",
  AppUsed = "app_used",
  DeactivatedUsers = "deactivated_users",
  Keyword = "keyword",
  LastRun = "last_run",
  OwnedByMe = "owned_by_me",
  Owner = "owner",
  Pending = "pending",
  SharedWithMe = "shared_with_me",
  ZapStatus = "zap_status",
}

interface EmitOptions {
  optionSelected: ZapSearchInteractionOptions;
  interactionRawText?: string;
}

export function useEmitZapSearchInteractionEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    ({ optionSelected, interactionRawText }: EmitOptions) => {
      emitUserInteractionEvent({
        accountId,
        eventAction: "click",
        interactionName: UserInteractionName.ZapSearchInteraction,
        interactionRawText,
        optionSelected,
        systemName: SERVICE_NAME,
      });
    },
    [accountId],
  );

  return {
    emit,
  };
}
